export default {
  'gifts.router.name': 'Gian quà xanh',
  'gift-distribution-history.router.name': 'Lịch sử phát quà',
  'gift-distribution-history-info.router.name': 'Thông tin lịch sử phát quà',
  'giftDistributionHistory.gift.time': 'Thời gian đổi quà',
  'giftDistributionHistory.gift.code': 'Mã đổi quà',
  'giftDistributionHistory.customer.name': 'Tên người dùng',
  'giftDistributionHistory.customer.phone': 'Số điện thoại',
  'giftDistributionHistory.device.code': 'Mã thiết bị',
  'giftDistributionHistory.device': 'Thiết bị',
  'giftDistributionHistory.device.name': 'Tên thiết bị',
  'giftDistributionHistory.gift.quantity': 'SL quà',
  'giftDistributionHistory.gift.status': 'Trạng thái',
  'giftDistributionHistory.gift.status.id':
    '{status,select, 1 {Đang xử lý} 2 {Thất bại} 3 {Thành công} 4 {Đã hủy} other {Không xác định}}',
  'giftDistributionHistory.gift.refundType': 'Trạng thái hoàn tiền',
  'giftDistributionHistory.gift.refundType.id':
    '{status,select, 1 {Hoàn tiền tự động} 2 {Hoàn tiền thủ công} other {Không xác định}}',
  'giftDistributionHistory.title.history': 'Thông tin lịch sử',
  'giftDistributionHistory.title.gifts': 'Danh sách quà tặng',
  'gifts.modalTransaction.title': 'Xác nhận hoàn giao dịch',
  'gifts.modalTransaction.note':
    'Hoàn giao dịch sẽ trả lại điểm cho khách hàng và có thể gây ra <span style={{color: #1A1A1A}}><strong>chênh lệch số lượng</strong></span> quà so với thực tế, bạn có chắc muốn thực hiện không?',
  'gifts.modalTransaction.reason': 'Lý do',
  'gifts.modalTransaction.reason.p': 'Nhập lý do hoàn giao dịch',
};
